import { useShallow } from 'zustand/react/shallow'

import { Source } from '@ui/__generated__/graphql'
import { Checkbox } from '@ui/components/core/Checkbox'
// import { Button } from '@ui/common/components/v1'
import { sourceTypeToLogoAssetSlug } from '@ui/constants/sources'
import { useLogoPathBySlug } from '@ui/lib/hooks/useLogoPathBySlug'
import { GetSourcesQuery } from '@ui/loaders/sources'
import { useSaveUpdateStatusStore } from '@ui/stores'
import { useLayoutPanelManagerStore } from '@ui/stores/pipelinesWorkflow'

import { LayoutPanel } from '../PipelineLayoutManager'
import { PanelContainer } from './Containers'

export const AssignSources = () => {
  const { data, loading, error } = GetSourcesQuery()

  const { assignedSourceIds, setAssignedSourceIds } = useSaveUpdateStatusStore(
    useShallow((state) => ({
      assignedSourceIds: state.assignedSourceIds,
      setAssignedSourceIds: state.setAssignedSourceIds,
    }))
  )

  const { setPanelContent } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      setPanelContent: state.setPanelContent,
    }))
  )

  const logoPathBySlug = useLogoPathBySlug(data?.sources.map((source) => sourceTypeToLogoAssetSlug[source.type]))

  const onSelect = (source: Source) => {
    const updatedAssignedSourceIds = new Set(assignedSourceIds)

    if (updatedAssignedSourceIds.has(source.id)) {
      updatedAssignedSourceIds.delete(source.id)
    } else {
      updatedAssignedSourceIds.add(source.id)
    }

    setAssignedSourceIds({ assignedSourceIds: updatedAssignedSourceIds, updatePipelineModified: true })
  }

  const closePanel = () => {
    setPanelContent({ panel: LayoutPanel.RIGHT_PANEL, content: null, open: false })
  }

  return (
    <PanelContainer
      title="Sources"
      subtitle="Your pipeline path is currently sourcing data from these sources. You may change your selection or add a new
      source"
      loading={loading}
      error={error}
      onClose={closePanel}>
      {/* TODO: Add Source flow*/}
      {/* <div className="px-4 py-2">
            <Button label="Add Source" variant="tertiary" className="w-full" size="small" />
          </div> */}
      {data?.sources.map((source) => (
        <div key={source.id} className="mx-4 my-2 rounded-md border border-gray-200 p-4">
          <div className="flex h-7 items-center gap-2">
            <img src={logoPathBySlug[sourceTypeToLogoAssetSlug[source.type]]} alt={source.type} className="h-7 w-7" />
            <p className="flex-1 text-xs">{source.name}</p>
            <Checkbox
              onChange={() => onSelect(source)}
              variant="secondary"
              checked={assignedSourceIds.has(source.id)}
            />
          </div>
        </div>
      ))}
    </PanelContainer>
  )
}
